import { useEffect } from 'react'

import { useReduxDispatch } from '@/store/hooks'
import { userActions } from '@/store/user'

export const FirebaseInitializer = () => {
  const dispatch = useReduxDispatch()

  useEffect(() => {
    dispatch(userActions.authLoading())
  }, [dispatch])

  return null
}
